(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yelvaro-withdrawal"]) return;
  try {
    
  (() => {
    const init = () => {
      const form = document.getElementById('YelvaroWithdrawalForm');
      const labelNode = document.getElementById('YelvaroWithdrawalLabels');
      if (!form || !labelNode || form.dataset.ywReady) return;
      form.dataset.ywReady = 'true';
      const labels = labelNode.dataset;
      const key = 'yelvaro_withdrawal_pending';
      const success = form.querySelector('[data-yw-success]');
      if (success) {
        let pending = null;
        try { pending = JSON.parse(sessionStorage.getItem(key)); sessionStorage.removeItem(key); } catch (_) {}
        if (pending && Date.now() - pending.savedAt < 3600000 && Date.now() >= pending.savedAt) {
          const receipt = labels.title + '\n\nYelvaro — INGRAMSTEVEN\n18726 88TH PL SE, SNOHOMISH, WA 98290, États-Unis\nreadycare@yelvaro.com\n\n' + pending.text + '\n\n' + labels.sent + ' : ' + pending.sentAt + '\n' + labels.accepted + ' : ' + success.dataset.ywConfirmedAt;
          document.getElementById('YelvaroWithdrawalReceipt').textContent = receipt;
          const download = document.getElementById('YelvaroWithdrawalDownload');
          download.href = URL.createObjectURL(new Blob([receipt], {type:'text/plain;charset=utf-8'}));
          download.download = 'Yelvaro-retractation-' + pending.savedAt + '.txt';
          download.hidden = false;
        } else {
          document.getElementById('YelvaroWithdrawalReceiptMissing').hidden = false;
        }
        return;
      }
      const fields = document.getElementById('YelvaroWithdrawalFields');
      const review = document.getElementById('YelvaroWithdrawalReview');
      const reviewButton = document.getElementById('yw-review');
      const confirmCheck = document.getElementById('yw-confirm-check');
      const getText = () => ['name','email','contract','products','statement'].map(name => labels[name] + ' : ' + document.getElementById('yw-'+name).value.trim()).join('\n\n');
      const showReview = () => {
        if (!form.reportValidity()) return;
        document.getElementById('YelvaroWithdrawalSummary').textContent = getText();
        fields.hidden = true;
        review.hidden = false;
        confirmCheck.disabled = false;
        review.focus();
      };
      reviewButton.hidden = false;
      reviewButton.addEventListener('click', showReview);
      document.getElementById('yw-edit').addEventListener('click', () => {
        confirmCheck.checked = false;
        confirmCheck.disabled = true;
        review.hidden = true;
        fields.hidden = false;
        document.getElementById('yw-name').focus();
      });
      form.addEventListener('submit', event => {
        if (review.hidden) { event.preventDefault(); showReview(); return; }
        if (!confirmCheck.checked) { event.preventDefault(); confirmCheck.reportValidity(); return; }
        const pending = {text:getText(),sentAt:new Date().toISOString(),savedAt:Date.now()};
        document.getElementById('yw-body').value = pending.text + '\n\n' + labels.sent + ' : ' + pending.sentAt;
        try { sessionStorage.setItem(key,JSON.stringify(pending)); }
        catch (_) { document.getElementById('yw-storage-error').hidden = false; }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();
})();
